import React from 'react'

import {useNavigate, useLocation, Link} from 'react-router-dom';

import * as CONSTANTS from '../../../Constants';
import  * as COMMONFUNCTIONS from '../../../utils/CommonFunctions';

import Loader from '../../../components/pages/loader';

import {useTranslation} from 'react-i18next'


function Member_Profile(props)
{
    const {t} = useTranslation();

    return (
        <div class="modal fade bg-white" id="member_profile_modal">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">

                    {/* Modal Header */}
                    <div class="modal-header">
                        <h1 class="modal-title seninter-tit">
                            <span className='intename2 font-20'>{CONSTANTS.PROJECT_TITLE}</span>
                        </h1>
                        {/* <button type="button" class="close" data-dismiss="modal">&times;</button> */}
                    </div>

                    {/* Modal body */}
                    <div class="modal-body pd-0">
                    {/* {
                        (props.userData.length > 0) ?  */}
                        {
                            (props.isMemberSelected) ? 
                            <section>
                                <div class="profi-pg profi-ban">
                                    <div class="">
                                        <div class="">
                                            <div class="profile">
                                                <div class="pg-pro-big-im">
                                                    <div class="s1">
                                                        {/* <img src={"/assets/images/profiles/profile-large.jpg?x="+CONSTANTS.RANDOM_PWD} loading="lazy" class="pro" alt="" /> */}
                                                        { props.getMemberImage(props.userData) }
                                                        <i class="fa fa-arrow-circle-o-left float-right mv-pro font-35" data-toggle="modal" data-target="#user_introduction" aria-hidden="true" style={{position: 'fixed',top: 2+'%', right: 15+'px', zIndex: 999, opacity: 0.7, backgroundColor: '#FFF', width: 38+'px', padding:2+'px', borderRadius:25+'px' }} onClick={() =>  {props.modalCloseMemberProfileBtnRef.current.click(); props.setMemberSelected(false);} /* navigate('/members.html') */}></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="profi-pg profi-bio">
                                                <div class="lhs">
                                                    <div class="pro-pg-intro">
                                                        <h1>{ COMMONFUNCTIONS.camelCase(props.userData.first_name+' '+props.userData.last_name) }</h1>
                                                        <div class="pro-info-status">
                                                            <span class="stat-1"><b>100</b> viewers</span>
                                                            <span class="stat-2"><b>Available</b> online</span>
                                                        </div>
                                                        <ul>
                                                            {
                                                                (props.userBasicInfoData.marital_status_title) ? <li>
                                                                    <div>
                                                                        <span>Marital Status: <strong>{ props.userBasicInfoData.marital_status_title }</strong></span>
                                                                    </div>
                                                                </li> : ''
                                                            }
                                                            {
                                                                (props.userData.age) ? <li>
                                                                    <div>
                                                                        {/* <img src={"/assets/images/icon/pro-age.png?x="+CONSTANTS.RANDOM_PWD} loading="lazy" alt=""/> */}
                                                                        <span>Age: <strong>{ props.userData.age } Yrs</strong></span>
                                                                    </div>
                                                                </li> : ''
                                                            }
                                                            {
                                                                (props.userData.height) ? <li>
                                                                    <div>
                                                                        {/* <img src={"/assets/images/icon/pro-city.png?x="+CONSTANTS.RANDOM_PWD} loading="lazy" alt=""/> */}
                                                                        <span>Height: <strong>{ props.userData.height } Feet</strong></span>
                                                                    </div>
                                                                </li> : ''
                                                            }
                                                            {
                                                                (props.userBasicInfoData.on_behalf_title) ? <li>
                                                                    <div>
                                                                        {/* <img src={"/assets/images/icon/pro-city.png?x="+CONSTANTS.RANDOM_PWD} loading="lazy" alt=""/> */}
                                                                        <span>Registered: <strong>{ props.userBasicInfoData.on_behalf_title }</strong></span>
                                                                    </div>
                                                                </li> : ''
                                                            }
                                                        </ul>
                                                    </div>
                                                    {/* PROFILE ABOUT */}
                                                    {
                                                        (props.userData.introduction) ? <div class="pr-bio-c pr-bio-abo">
                                                            <h3>About</h3>
                                                            <p>{ props.userData.introduction }</p>
                                                        </div> : ''
                                                    }
                                                    
                                                    {/* END PROFILE ABOUT */}

                                                    {/* INTRODUCTION */}

                                                    { (props.userData.introduction != "") ? <div class="pr-bio-c pr-bio-conta"><h3>Introduction</h3><b>{ props.userData.introduction }</b></div> : '' }
                                                    
                                                    {/* END INTRODUCTION */}

                                                    {/* PROFILE ABOUT */}
                                                    <div class="pr-bio-c pr-bio-info">
                                                        <h3>Personal information</h3>
                                                        <ul>
                                                            <li><b>Name:</b> { COMMONFUNCTIONS.camelCase(props.userData.first_name+' '+props.userData.last_name) }</li>

                                                            { (props.userData.member_profile_id != "") ? <li><b>Profile ID:</b> { props.userData.member_profile_id }</li> : '' }
                                                            
                                                            <li><b>Age:</b> { props.userData.age } Years</li>
                                                            <li><b>Date of birth:</b> { props.userData.date_of_birth }</li>

                                                            { (props.userBasicInfoData.marital_status_title != "") ? <li><b>Marital Status:</b> { props.userBasicInfoData.marital_status_title }</li> : '' }

                                                            { (props.userData.height > 0) ? <li><b>Height:</b> { props.userData.height } Feet</li> : '' }
                                                          
                                                            { (props.userEducationCareerData.highest_education_title) ? <li><b>Education:</b> { props.userEducationCareerData.highest_education_title }</li> : '' }

                                                            { (props.userEducationCareerData.occupation_title) ? <li><b>Occupation:</b> { props.userEducationCareerData.occupation_title }</li> : '' }

                                                            { (props.userSpiritualData.caste_title) ? <li><b>Caste:</b> { props.userSpiritualData.caste_title }</li> : '' }

                                                            { (props.userSpiritualData.religion_title) ? <li><b>Religion:</b> { props.userSpiritualData.religion_title }</li> : '' }

                                                            { (props.userLanguageData.mother_tongue_title) ? <li><b>Mother Tongue:</b> { props.userLanguageData.mother_tongue_title }</li> : '' }

                                                            { (props.userPermanentAddressData.permanent_city_title) ? <li><b>City:</b> { props.userPermanentAddressData.permanent_city_title }</li> : '' }

                                                            { (props.userPermanentAddressData.permanent_state_title) ? <li><b>State:</b> { props.userPermanentAddressData.permanent_state_title }</li> : '' }
                                                        </ul>
                                                    </div>
                                                    {/* END PROFILE ABOUT */}

                                                </div>

                                                {/* PROFILE lHS */}
                                                <div class="rhs">
                                                    {/* HELP BOX */}
                                                    <div class="prof-rhs-help">
                                                        <div class="inn">
                                                            <h3>Tell us your Needs</h3>
                                                            <p>Tell us what kind of service or experts you are looking.</p>
                                                            {(props.isLoggedIn) ? <Link to="/contact.html">Contact Us</Link> : <Link to="/sign-up.html">Register</Link> }
                                                        </div>
                                                    </div>
                                                    {/* END HELP BOX */}
                                                </div>
                                                {/* END PROFILE lHS */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section> : <Loader />
                        }
                        
                        {/* : ''
                    } */}
                    </div>

                    {/* Modal footer */}
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal" ref={props.modalCloseMemberProfileBtnRef}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Member_Profile